import styled from 'styled-components';

export const Container = styled.div`
  font-size: 3rem;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.lightBlue};

  svg {
    width: 24px;
    color: ${({ theme }) => theme.colors.lightBlue};
    fill: ${({ theme }) => theme.colors.lightBlue};
  }
`;
